<template>
  <div>
    <BusinessSwitchModal></BusinessSwitchModal>
    <WarningModal></WarningModal>
      <div v-if="!!userProfile">
        <div
          class="d-flex align-items-center position-relative h-100"
          :id="isQualifiedBorrower ? 'borrower-qualified-app-nav' : 'borrower-dnq-app-nav'"
          @mouseleave="setDropdown('dropdown_user', !dropdown_user.active)"
        >
        <div class="marketplace-username-container" :class="{ 'is-modern': isModern, 'hide-sign-in': hideSignin }">
          <!-- Mobile -->
            <a v-if="!portal && contactInfoEnabled && !hideContactInfo" :href="customerServiceNumberLink" class="d-sm-block d-lg-none d-none call-us me-4 pe-4 type-500">Need help? <br/>{{ customerServiceNumber }}</a>
            <p
              :class="{ 'portal-nav': full }"
              class="d-lg-none marketplace-nav-link m-0 text-truncate"
              @click="setDropdown('dropdown_user', !dropdown_user.active)"
            >
              <fa-icon v-if="!portal" :icon="['far', 'circle-user']"></fa-icon>
              <span v-if="!portal" data-cy="username" class="username text-capitalize p-sm fw-bold ms-2">{{ displayName }}</span>
            </p>
            <!-- Desktop -->
            <div v-if="!portal && contactInfoEnabled && !hideContactInfo" class="call-us d-none d-lg-block me-4 pe-4 type-500"  @mouseenter="setDropdown('dropdown_user', !dropdown_user.active)">Need help? Call {{ customerServiceNumber }}</div>
            <div
              :class="{ 'portal-nav': full}"
              class="d-none d-lg-flex marketplace-nav-link desktop-profile-link text-truncate align-items-center bg-white p-1"
              @mouseenter="setDropdown('dropdown_user', true)"
            >
              <div class="desktop-icon-gray-background d-flex align-items-center justify-content-center">
                <fa-icon :icon="['far', 'circle-user']"></fa-icon>
              </div>
              <span data-cy="username" class="username text-capitalize text-truncate p-sm fw-bold ms-2 me-5">{{ displayName }}</span>
            </div>
          </div>
          <div v-show="dropdown_user.active" :class="(portal) ? 'marketplace-portal-submenu p-3' : 'marketplace-submenu'">
            <div class="nav-wrap ms-4 me-2 m-lg-0 full-submenu-pointer">
              <ul>
                <li v-for="link in appNavPortalLinks" :key="kebabString(link.title)" @mouseover='linkHover=link.title' @mouseleave='linkHover=""' :style="{ cursor: 'pointer' }">
                  <a v-if="checkActionLink(link.title)" data-cy="logout" class="d-block align-middle m-4 text-start" @click="handleSignOut($event)" id="app-nav-sign-out">
                    <NuxtImg class="align-middle mb-1 me-2" v-if="link.imgIcon" :src="formatImagePath(link.imgIcon)" />
                    <fa-icon v-else :icon="['far', link.faIcon]" class="fa-fw me-2"></fa-icon>
                    {{link.title}}
                  </a>
                  <a v-if="checkModalLink(link.title)" data-cy="switch-business" class="d-block align-middle m-4 text-start" @click="businessSwitchToggle(true)" id="switch-business">
                    <NuxtImg class="align-middle mb-1 me-2" v-if="link.imgIcon" :src="formatImagePath(link.imgIcon)" />
                    <fa-icon v-else :icon="['far', link.faIcon]" class="fa-fw me-2"></fa-icon>
                    {{link.title}}
                  </a>
                  <router-link v-if="neitherActionOrModalLink(link.title)" :to="link.url" class="d-block align-middle m-4 text-start" :class="{'current': $route.path === link.url}" :data-cy="'side-nav-' + kebabString(link.title)">
                    <NuxtImg class="align-middle mb-1 me-2" v-if="link.imgIcon" :src="formatImagePath(link.imgIcon)" />
                    <fa-icon v-else :icon="['far', link.faIcon]" class="fa-fw me-2"></fa-icon>
                    {{link.title}}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
      <div v-else-if="!isModern">
        <div class="marketplace-username-container no-user h-100" :class="{ 'hide-sign-in': hideSignin }">
          <!-- Mobile -->
          <span v-if="hideSignin" class="hide-sign-in"></span><!-- This is a slight hack to hide the border right because the reactivity for adding a class isn't working on refresh, but a v-if is... Very strange. -->
          <a v-if="contactInfoEnabled"
            :href=customerServiceNumberLink
            class="d-md-none d-sm-block call-us me-3 pe-3 type-500">Need help? <br>{{ customerServiceNumber }}</a>
          <!-- Desktop -->
          <p v-if="contactInfoEnabled"
            class="call-us d-none d-md-block me-4 pe-4 mb-0 type-500">Need help? Call {{ customerServiceNumber }}</p>

          <template v-if="!hideSignin">
            <a data-cy="sign-in" class="sign-in" :class="{'customized-affiliate': !!affiliateCustomizations}" href="javascript:;" @click="$router.push({ path: loginPath })">Sign In</a>
          </template>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { usePortalStore } from '~/store/portal'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'
import { useBorrowerStore } from '~/store/borrower'
import { useBusinessSwitchStore } from '~/store/business-switch'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { useTenantStore } from '~/store/tenant'
import env from '~/libs/env'
import { phone } from '~/libs/format'
import { PORTAL_NAV_TITLES } from '~/libs/portal-constants'
import get from 'lodash/get'
import WarningModal from './WarningModal.vue'
import BusinessSwitchModal from '../components/BusinessSwitchModal.vue'
import { useProgressStore } from '~/store/progress'
import formatImagePath from '~/libs/image-format'

export default {
  name: 'AppNav',
  components: {
    WarningModal,
    BusinessSwitchModal
  },
  setup () {
    return { formatImagePath }
  },
  data () {
    return {
      collapse: true,
      dropdown_user: { active: false, clicked: false },
      linkHover: '',
      loggingOut: false,
    }
  },
  props: {
    full: {
      type: Boolean,
      default: false
    },
    hideAppCta: {
      type: Boolean,
      default: false
    },
    portal: {
      type: Boolean,
      default: false
    },
    isModern: {
      type: Boolean,
      default: false,
    },
    hideContactInfo: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$route.path' () {
      this.dropdown_user.active = false
      this.dropdown_user.clicked = false
    }
  },
  computed: {
    ...mapState(usePortalStore, ['navLinks', 'currentPage', 'isQualifiedBorrower']),
    ...mapState(useRootStore, ['userProfile', 'isGuest']),
    ...mapState(useTenantStore, ['isTenant']),
    ...mapState(useBorrowerStore, {
      borrowerName: store => get(store, 'borrower.name'),
      testBorrower: store =>  get(store, 'borrower.isTest'),
      applicationComplete: store =>  get(store, 'borrower.applicationComplete')
    }),
    ...mapState(useUserStore, ['hasMultipleBorrowers']),
    ...mapState(useBorrowerStore, ['mpApplicationComplete']),
    ...mapState(useProgressStore, ['currentApp']),
    ...mapState(useAffiliateCustomizationStore, [
      'affiliateCustomizations',
      'contactInfoEnabled',
      'contactInfoPhone',
      'isSupportedApplication'
    ]),
    customerServiceNumber () {
      const value = this.contactInfoPhone ?? env('customerServicePhoneNumber')
      return phone(value)
    },
    customerServiceNumberLink () {
      const value = this.contactInfoPhone ?? env('customerServicePhoneNumber')
      return 'tel:' + value
    },
    displayName () {
      if (this.borrowerName) {
        return this.borrowerName
      }
      if (this.userProfile && this.userProfile.first && this.userProfile.last) {
        const fullLength = this.userProfile.first.length + this.userProfile.last.length + 1
        if (fullLength <= 16) {
          return this.userProfile.first + ' ' + this.userProfile.last
        }
        return this.userProfile.first
      }
      return ''
    },
    appNavPortalLinks() {
      const appNavLinks = [PORTAL_NAV_TITLES.DASHBOARD, PORTAL_NAV_TITLES.SIGN_OUT, PORTAL_NAV_TITLES.SWITCH_BUSINESS]
      const requiresAppComplete = [PORTAL_NAV_TITLES.DASHBOARD, PORTAL_NAV_TITLES.SETTINGS]
      return this.navLinks.filter(link => {
        if (!this.applicationComplete && requiresAppComplete.includes(link.title)) {
          return false
        }
        return appNavLinks.includes(link.title)
      })
    },
    ctaLink () {
      return '/basic-info'
    },
    /**
     * Determines the proper styling for the page based on the route
     * @returns {string} A string containing the proper css styling
     */
    setAppNavStyle() {
      // The original style conditional was a 241-character long, single-line conditional
      // So I've broken out that conditional into something more readable

      let style = ''  // The default styling should be left to the class
      if (this.hideSignup) { // If we are hiding our signup block...
        style = 'float: none;'
      } else { // otherwise...
        // We need to use route.name a lot, so store its value as a scoped property.
        const routeName = this.$route.name
        // Validate that routeName is defined and truthy so we don't throw errors later.
        if (routeName) {
          // We initially still assume that we are leaving the styling to the class.
          let displayAsFlex = false
          // However, if we're on the login page, we'll display as flex
          if (routeName.includes('login')) displayAsFlex = true
          // Also if the user isn't logged in,
          else if (!this.userProfile) {
            // we'll display as flex if they're on the basic-info or owner-info page.
            if (routeName.includes('basic-info') || routeName.includes('owner-info')) {
              displayAsFlex = true
            }
          }
          if (displayAsFlex) {
            // If the "displayAsFlex" flag is set as true, set the styling to flex.
            style = 'display: flex; align-items: center;';
          }
        }
      }
      return style
    },
    isGuestPage() {
      return this.$route.path.startsWith('/guest/')
    },
    hideSignin() {
      return this.isGuestPage && this.isGuest
    },
    hideSignup() {
      return env('hideSignup') === 'true' || this.hideAppCta
    },
    loginPath() {
      return '/login'
    }
  },
  methods: {
    checkActionLink(linkTitle) {
      return linkTitle === PORTAL_NAV_TITLES.SIGN_OUT
    },
    checkModalLink(linkTitle) {
      return linkTitle === PORTAL_NAV_TITLES.SWITCH_BUSINESS && this.hasMultipleBorrowers
    },
    neitherActionOrModalLink(linkTitle) {
      linkTitle === PORTAL_NAV_TITLES.SWITCH_BUSINESS || linkTitle === PORTAL_NAV_TITLES.SIGN_OUT
    },
    toggleCollapse () {
      this.collapse = !this.collapse
    },
    route (path) {
      const [ , params ] = this.$route.fullPath.split('?')
      const query = params ? `?${params}` : ''
      this.$router.push(`${path}${query}`)
    },
    checkCurrentPath(linkUrl) {
      if (linkUrl === PORTAL_NAV_URLS.OFFERS) {
        return this.$route.path.includes(linkUrl)
      }
      return this.$route.path === linkUrl
    },
    logout () {
      this.loggingOut = true
      this.dropdown_user = { active: false, clicked: false }
      useRootStore(this.$pinia).logout({ $router: this.$router, path: this.$route && this.$route.path })

      if (typeof window.logout !== 'undefined') {
        window.logout()
      }
    },
    setDropdown (name, val = true) {
      if (name && this[name] !== undefined) {
        this[name].active = val
      }
    },
    clickDropdown (name) {
      if (name && this[name].clicked !== undefined) {
        this[name].clicked = !this[name].clicked
      }
    },
    kebabString(str) {
      return str.replace(/\s/g , "-").toLowerCase()
    },
    handleSignOut($event) {
      $event.stopPropagation();
      this.logout()
    },
    businessSwitchToggle(value) {
      useBusinessSwitchStore(this.$pinia).businessSwitchModalToggle(value)
    },
  }
}
</script>

<style>
/* THIS ISNT NECESSARY IF THIS HEADER ISNT ON LEGACY ROUTES! */
html {
  font-size: 16px !important;
}
</style>

<style lang="scss" scoped>
$app-primary-color: var(--app-primary-color);

/* New Design */
.sign-in .customized-affiliate {
  color: $app-primary-color;
}

.call-us {
border-right: 1px solid $border-300;
font-size: 14px;
@include media-breakpoint-down(sm) {
    border: none;
  }
}

.hide-sign-in > .call-us,
.hide-sign-in ~ .call-us {
  border-right: none;
  margin-right: 0 !important;
  padding-right: 0 !important;
}

.marketplace-nav-link {
  color: $type-600;
  cursor: pointer;
}

.marketplace-submenu {
  position: absolute;
  z-index: 1005;
  width: 280px;
  padding: 12px;
  top: 56px;
  right: -30px;
  @include media-breakpoint-up(lg) {
    top: 50px;
    right: -10px;
  }
}

.marketplace-portal-submenu {
  position: absolute;
  z-index: 1005;
  width: 260px;
  top: 50px;
  right: -10px;
}

.marketplace-username-container {
  max-width: 464px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1005;
  white-space: nowrap;
  vertical-align: middle;
}

@include media-breakpoint-down(sm) {
  .marketplace-username-container:not(.is-modern) {
    max-width: 170px;
  }
}

@media (max-width: 400px) {
  .no-user {
    .call-us {
      display: none !important;
    }
  }
}

.desktop-profile-link {
  border-radius: 40px;
  border: 1px solid #DADFE3;
}
.desktop-icon-gray-background {
  height: 40px;
  width: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 20px;
  background: $disabled-background;
}

/* End New Design */
  .nav-link:hover {
    color: #05c2f0;
  }
 .navbar-toggler-icon {
          background-image: url('https://lendio.com/assets/img/header/toggle-dark.svg');
        }
.desktop-sign-in {
  display: flex;
  list-style: none;
  padding-top: .8rem;
  @include media-breakpoint-down(lg) {
    display: block;
    padding-left: 0;
    padding-top: 0;
  }
}
.navbar .navbar-nav .nav-link {
  font-size: 13px;
  font-weight: normal;
  @include media-breakpoint-down(lg) {
    text-transform: none;
  }
}
.link-container {
  position: relative; // For catching submenus
  margin-right: 1rem;
}
.username {
  text-transform: uppercase;
  letter-spacing: .5px;
}
.submenu {
  z-index: 100;
  position: absolute;
}
.submenu-default {
  top: 100%;
  margin: 0 auto;
  right: -1px;
  width: 10rem;
  @include media-breakpoint-up(xl) {
    margin: 0 auto;
    right: -50px;
    left: -50px;
  }
}
.submenu-full {
  width: 260px;
  left: -140px;
}
.submenu-full, .full-submenu-pointer::before, .full-submenu-pointer::after  {
  padding-top: 12px;
}
.submenu__links {
  background-color: #fff;
  border: 1px solid rgba(26,19,17,0.15);
  border-radius: 0.25rem;
  padding: 1.25rem;
  padding-bottom: 0.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  & div {
    margin-bottom: 0.75rem;
  }
}
.submenu__pointer {
  position: relative;
  width: 18px;
  height: 9px;
  margin-left: calc(100% - 3rem);
  background-image: url('https://www.lendio.com/wp-content/themes/lendio-standards/images/header/submenu-pointer-stroke.png');
  // Border cover
  &:after {
    content: '';
    background-color: #FFF;
    // Center
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 100%; // Put at the bottom of the image above
    width: 14px; // 4 px less than the width of the image
    height: 2px; // 1 px bigger than height of the border you want to cover
  }
  @include media-breakpoint-up(xl) {
    margin: 0 auto;
  }
}
.navbar__link {
  font-weight: 400;
  text-decoration: none;
  color: #1a1311;
  font-size: 13px;
  white-space: nowrap;
  @include media-breakpoint-down(lg) {
            font-size: 13px;
            margin-left: 15px;
          }
  &:hover, &.nuxt-link-active {
    color: #05c2f0;
    cursor: pointer;
  }
}
.portal-nav > :not(.username, .desktop-icon-gray-background) {
  font-size: 14px;
  &:hover {
    color: #0091FF;
  }
}
.site-header-sign-in {
    padding-left: 1rem;
    padding-right: 1rem;
    color: #05c2f0;
    padding-top: .6rem;
    right: 200px;
    top: 25px;
    font-size: 13px;
    text-transform: uppercase;
    line-height: 26px;
    z-index: 3;
    transition: right .2s cubic-bezier(.455,.03,.515,.955);
    text-decoration: none;
    @include media-breakpoint-down(lg) {
      padding-left: 0;
      padding-right: 8px;
    }
}
.sign-in-class {
  padding: .7rem;
  a {
    color: #05c2f0;
    @include media-breakpoint-down(lg) {
      text-transform: none;
      color: #000;
    }
  }

}
.site-header-start-btn {
  padding-left: 1rem;
  padding-right: 1rem;
  display: block;
  height: 39px;
  width: 175px;
  background-repeat: no-repeat;
  line-height: 40px;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  right: 10px;
  top: 18px;
  font-size: 14px;
  z-index: 2;
  opacity: 1;
  transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,opacity .4s cubic-bezier(.455,.03,.515,.955);
  @include media-breakpoint-down(lg) {
    font-size: 13px;
    font-weight: 500;
  }
}
a.primary-button, button.primary-button {
    background-color: #05c2f0;
    vertical-align: middle;
    letter-spacing: 1.5px;
    height: 39px;
    color: #fff;
    border: transparent;
    border-top-color: transparent;
    border-radius: 30px;
    @include media-breakpoint-down(lg) {
      height: 45px;
    }
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,opacity .4s cubic-bezier(.455,.03,.515,.955);
    transition-property: background-color, border-color, box-shadow, opacity;
    transition-duration: 0.15s, 0.15s, 0.15s, 0.4s;
    transition-timing-function: ease-in-out, ease-in-out, ease-in-out, cubic-bezier(0.455, 0.03, 0.515, 0.955);
    transition-delay: 0s, 0s, 0s, 0s;
}
  .full-nav {
      color: #000;
      &.navbar {
        padding: 0;
        padding-top: 5px;
        @include media-breakpoint-down(lg) {
          padding: 0px;        }
        .navbar-toggler-icon {
          background-image: url('https://lendio.com/assets/img/header/toggle-dark.svg');
        }
        .nav-item {
          letter-spacing: 0;
          text-transform: none;
          font-size: 13px;
          @include media-breakpoint-down(lg) {
            letter-spacing: 0;
          }
          a {
            white-space: nowrap;
            padding-bottom: 1rem;
            @include media-breakpoint-down(xl) {
              font-size: 1rem;
            }
            @include media-breakpoint-up(md) {
              font-size: 1rem;
              margin-left: 12px;
            }
          }
          .dropdown-menu {
            padding: 1rem;
            margin: 0;
            font-size: 13px;
            border: 1px solid #BBC7D7;
            border-radius: 2px;
            line-height: 1.6;
            text-transform: none;
            width: 234px;
            left: -60px;
            a {
              white-space: normal;
              margin-bottom: 4px;
              font-size: 1.1rem;
              @include media-breakpoint-down(lg) {
                font-size: 13px;
              }
            }
            .dropdown-divider, h4 {
              margin: 13px 24px;
            }
            h4 {
              font-size: 16px;
              text-transform: none;
            }
            .submenu-pointer {
              position: absolute;
              top: -9px;
              left: 108px;
              width: 18px;
              height: 9px;
              background-image: url('https://lendio.com/wp-content/themes/lendio-standards/images/header/submenu-pointer-stroke.png');
              background-repeat: no-repeat;
            }
          }
        }
        .sign-in-div {
          margin-left: auto;
          right: 120px;
          top: 0px;
          font-size: 13px;
          font-weight: 400;
          line-height: 24px;
          @include media-breakpoint-down(lg) {
            position: static;
            font-size: 1.1rem;
          }
        }
        .navbar-close {
          position: absolute;
          display: block;
          top: 30px;
          right: 30px;
          cursor: pointer;
          z-index: 1003;
          width: 12px;
          height: 13px;
          background-image: url('https://lendio.com/wp-content/themes/lendio-standards/images/header/submenu-close.svg');
          background-repeat: no-repeat;
        }
        #navbarFull {
          @include media-breakpoint-down(lg) {
            .dropdown {
              position: static;
            }
            background: #fff;
            position: fixed;
            width: 100%;
            height: 100%;
            right: calc(100% * -1);
            top: 0;
            z-index: 1000;
            transition: right .2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
            padding: 40px 20px;
            overflow-y: scroll;
            &.show {
              right: 0px;
            }
            .nav-item {
              height: auto;
              text-align: left;
              padding: 0;
              padding-top: 15px;
              .nav-link-container {
                position: relative;
                .mobile-sub-overlay {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 10;
                }
              }
              a {
                color: #050302;
                padding-bottom: 28px;
                padding-top: 28px;
                border-bottom: 1px solid #BBC7D7;
                position: relative;
                font-weight: 500;
              }
              .nav-link {
                position: inherit;
                display: block;
                font-size: 20px;
                margin: 0 30px;
                padding-top: .7rem;
                padding-left: 1rem;
                .dropdown-caret {
                  position: absolute;
                  display: block;
                  right: 0;
                  top: 36px;
                  height: 8px;
                  width: 6px;
                  background-repeat: no-repeat;
                  background-image: url('https://lendio.com/wp-content/themes/lendio-standards/images/header/submenu-caret.svg');
                }
              }
              .sign-in-link {
                a {
                  color:#05c2f0;
                  @include media-breakpoint-down(lg) {
                    color:#1a1311;
                  }
                }
              }
              .dropdown-menu {
                font-size: 13px;
                position: absolute;
                display: block;
                width: 100%;
                height: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                background: #fff;
                top: 0;
                right: calc(100% * -1);
                left: auto;
                margin: 0;
                transition: right 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
                z-index: 1002;
                padding: 1rem;
                border-radius: 0;
                opacity: 1;
                animation: none;
                border: none;
                @include media-breakpoint-down(lg) {
                  padding-top: 67px;
                }
                &.show {
                  right: 0;
                }
                a {
                  padding: 5px 0;
                  border-bottom: none;
                  margin-bottom: 12px;
                  &.dropdown-mobile-title {
                    display: block;
                    padding: 0 0 28px;
                    font-size: 20px;
                    background-repeat: no-repeat;
                    background-position: left 9px;
                    padding-left: 15px;
                    color: #05C2F0;
                    text-transform: uppercase;
                    border-bottom: 1px solid #BBC7D7;
                    letter-spacing: 1px;
                    font-weight: 500;
                    margin-bottom: 28px;
                  }
                }
                .dropdown-divider {
                  border-top: 2px solid #e3e9ef;
                  padding-top: 20px;
                  margin: 20px 0;
                }
                h4 {
                  margin: 20px 0;
                }
              }
            }
          }
        }
      }
    }
a.primary-button:hover, button.primary-button:hover {
    background-color: #74e2fd;
    border-color: #049abe;
    text-decoration: none;
}
a.primary-button:active, button.primary-button:active {
    background-color: #04a6cd;
    border: none;
    box-shadow: none;
    box-shadow: none;
}
a.nav-dropdown-link, a.nav-dropdown-link:hover {
  text-decoration: none;
  color: #1a1311;
  &:hover, &.nuxt-link-active {
    color: #05c2f0;
    cursor: pointer;
  }
}
.navbar .dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  width: 230px;
  padding-top: 1rem;
  margin: 0 auto;
  .tri-up {
    position: absolute;
    width: 0;
    height: 0;
    margin: 0 auto;
    z-index: auto;
    top: -8px;
    left: 0;
    right: 0;
    border-style: solid;
    border-color: transparent;
    border-top: 0;
    border-bottom-color: #FFF;
    border-width: 9px;
    &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-color: transparent;
      border-top: 0;
      z-index: -1;
      top: -2px;
      left: -9px;
      border-bottom-color: #BBC7D7;
      border-width: 9px;
    }
  }
}
.sign-up-class {
  background-color: #05c2f0;
  transition-property: background-color,border-color,box-shadow,opacity;
  transition-duration: .15s,.15s,.15s,.4s;
  transition-timing-function: ease-in-out,ease-in-out,ease-in-out,cubic-bezier(.455,.03,.515,.955);
  transition-delay: 0s,0s,0s,0s;
  @include media-breakpoint-down(lg) {
    padding: 0;
    width: 100%;
    padding-top: 5px;
  }
}
.nav-wrap {
  background: #FFF;
  box-shadow: 0px 5px 14px rgba(0, 0, 0, 0.2);
  border-radius: 14px;
  ul {
    padding: 8px 0;
    margin: 0;
    list-style: none;
    li {
      a {
        padding: 8px 16px;
        border-radius: 18px;
        color: $black;
        &:hover, &.current {
          text-decoration: none;
        }
        &:hover {
          color: $primary;
          background: $background-100;
        }
        &.current {
          font-weight: bold;
          background: $background-200;
          i {
            color: $primary;
          }
        }
        img {
          display:inline-block;
          width: 18px;
        }
      }
    }
  }
}
.full-submenu-pointer {
  &:before {
    position:absolute;
    top:-10px; right:50px;
    content: '';
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #FFF;
    z-index:102;
  }
  &:after {
    /* This is the shadow triangle */
    position:absolute;
    top:-12px; right:48px;
    content: '';
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid rgba(0,0,0, 0.04);
    z-index:101;
  }
}
</style>
